export default [
    {
      path: '/admin/inventory/product-profiles',
      name: 'product-profile',
      meta: { requiresAuth: true },
      component: () => import('@/pages/inventory/product-profile/index.vue')
    }
  ]
